// extracted by mini-css-extract-plugin
export var animationContainer = "_fx-0";
export var asteriskIcon = "_fx-8";
export var conversationLeftSection = "_fx-4";
export var conversationListItem = "_fx-3";
export var conversationMiddleSection = "_fx-5";
export var conversationRightSection = "_fx-6";
export var detailsContent = "_fx-1";
export var listContainer = "_fx-7";
export var modalContent = "_fx-2";